<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="guideIndex" :areaShow="areaShow" :get-party-id="getPartyId"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a href="javascript:void(0)" @click="urlTo('applyIndex')">个人办事</a> / <a href="javascript:void(0)" @click="urlTo('guideIndex',{service_code:service_code,nav_name:nav_name})">{{nav_name}}办事指南</a> / <span>评价详细</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="schedule">

            <div class="conment_con1">
              <div class="conment_con1_left">
                <p class="conment_con1_tit">总评分</p>
                <p class="conment_con1_star"><el-rate
                  v-model="guideScore"
                  disabled
                  show-score
                  text-color="#ff9900"
                  score-template="{value}">
                </el-rate></p>
              </div>
              <div class="conment_con1_right">
                <dl>
                  <dt>一次评论</dt>
                  <dd>
                    <div style="display: flex;justify-content: left;height: 30px;line-height: 30px;">
                    <div style="width: 120px;">5星 | 非常满意</div>
                    <div style="width: 300px;padding-top: 5px;margin-left: 13px;">
                      <el-progress :text-inside="true" :stroke-width="20" :percentage="five"></el-progress>
                    </div>
                  </div>
                  </dd>
                  <dd><div style="display: flex;justify-content: left;height: 30px;line-height: 30px;"><div style="width: 120px;">4星 | 满意</div> <div style="width: 300px;padding-top: 5px;margin-left: 13px;"><el-progress :text-inside="true" :stroke-width="20" :percentage="four"></el-progress></div></div></dd>
                  <dd><div style="display: flex;justify-content: left;height: 30px;line-height: 30px;"><div style="width: 120px;">3星 | 基本满意</div> <div style="width: 300px;padding-top: 5px;margin-left: 13px;"><el-progress :text-inside="true" :stroke-width="20" :percentage="three" status="success"></el-progress></div></div></dd>
                  <dd><div style="display: flex;justify-content: left;height: 30px;line-height: 30px;"><div style="width: 120px;">2星 | 不满意</div> <div style="width: 300px;padding-top: 5px;margin-left: 13px;"><el-progress :text-inside="true" :stroke-width="20" :percentage="two" status="warning"></el-progress></div></div></dd>
                  <dd><div style="display: flex;justify-content: left;height: 30px;line-height: 30px;"><div style="width: 120px;">1星 | 非常不满意</div> <div style="width: 300px;padding-top: 5px;margin-left: 13px;"><el-progress :text-inside="true" :stroke-width="20" :percentage="one" status="exception"></el-progress></div></div></dd>
                </dl>
              </div>
            </div>
            <div class="clear"></div>
            <div class="conment_con2">
              <dl>
                <dt>评价列表</dt>
                <dd><span @click="clickListInfo('all')">全部（{{all_show}}）</span><span @click="clickListInfo('five')">非常满意（{{five_show}}）</span><span @click="clickListInfo('four')">满意（{{four_show}}）</span><span @click="clickListInfo('three')">基本满意（{{three_show}}）</span><span @click="clickListInfo('two')">不满意（{{two_show}}）</span><span style="width: 130px;" @click="clickListInfo('one')">非常不满意（{{one_show}}）</span></dd>
              </dl>
            </div>
            <div class="clear"></div>
            <table width="90%" border="0" cellspacing="1" cellpadding="0" class="conment_tab">
              <tr class="conment_tab_tit">
                <td  style="width: 180px;">评分</td>
                <td >评价内容</td>
                <td  style="width: 120px;">评价时间</td>
              </tr>
              <tr v-for="(item,index) in dataObjList" :key="item.id">
                <td class="conment_star"><el-rate
                  v-model="item.score"
                  disabled
                  show-score
                  text-color="#ff9900"
                  score-template="{value}">
                </el-rate></td>
                <td>{{item.content}}</td>
                <td>{{item.time}}</td>
              </tr>
            </table>
            <div class="clear"></div>
            <div style="text-align: center;height: 50px;line-height: 50px;width: 100%;"> <el-pagination
              layout="prev, pager, next"
              :total="total" :page-size="pageSize" @current-change="pageChange" @prev-click="prevClick" @next-click="nextClieck">
            </el-pagination>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
import headers from "../../components/Headers";
import fixedDiv from "../../components/FixedDiv";
import footers from "../../components/Footer";
export default {
  name: "public-index",
  components:{
    headers,fixedDiv,footers
  },
  data() {
    let _self=this;
    return {
      active: 'guideIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      party_id:'',
      nav_name:'',
      nav_name_apply:'',
      service_code:'',
      dataObjList:[],
      activeName:'0',
      areaShow:false,
      guideScore:4.5,
      guideId:'',
      five:0,
      four:0,
      three:0,
      two:0,
      one:0,
      all:0,
      total:0,
      five_show:0,
      four_show:0,
      three_show:0,
      two_show:0,
      one_show:0,
      all_show:0,

      pageNum:0,
      pageSize:6,
      searchType:'all',
    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
  },
  created(){

  },
  mounted(){
    this.nav_name=this.$route.query.nav_name;
    this.service_code=this.$route.query.service_code;
    this.guideId=this.$route.query.guideId;
    this.initData();
  },
  methods: {
    prevClick(a){
      this.pageNum=this.pageNum-1;
      this.initData();
    },
    nextClieck(a){
      this.pageNum=this.pageNum+1;
      this.initData();
    },
    pageChange(a){
      this.pageNum=a
      this.initData();
    },
    getBfb(a,all){
        return Math.round(a/this.all*100)
    },
    handleClick(){},
    getPartyId(a){
      this.party_id=a;
      this.initData();
    },
    getImg(imgId){
      var dd=this.$util.req.getshowImg(imgId);
      return dd;
    },
    clickListInfo(a){
      if(a ==this.searchType){
        return;
      }
      this.pageNum=1;
      if(a=='five'){
        if(this.five_show>0){
          this.searchType='five';
          this.initInfoData();
        }else{
          this.dataObjList=[];
        }
      }else if(a=='four'){
        if(this.four_show>0){
          this.searchType='four';
          this.initInfoData();
        }else{
          this.dataObjList=[];
        }
      }else if(a=='three'){
        if(this.three_show>0){
          this.searchType='three';
          this.initInfoData();
        }else{
          this.dataObjList=[];
        }
      }else if(a=='two'){
        if(this.two_show>0){
          this.searchType='two';
          this.initInfoData();
        }else{
          this.dataObjList=[];
        }
      }else if(a=='one'){
        if(this.one_show>0){
          this.searchType='one';
          this.initInfoData();
        }else{
          this.dataObjList=[];
        }
      }else{
        if(this.all_show>0){
          this.searchType='all';
          this.initInfoData();
        }else{
          this.dataObjList=[];
        }
      }
    },
    initData(){
      const options={
        guideId:this.guideId
      }
      this.$https.post("api/guide/getGuideScoreListWeb.do",options,response=>{
        if (response.status === 200 && response.data.code===200 && response.data.data) {
          this.guideScore=response.data.data['score'];
          if(response.data.data['all'] !=0){
            this.all_show=response.data.data['all']
          }
          if(response.data.data['5'] !=0){
            this.five= Math.round(response.data.data['5']/response.data.data['all']*100);
            this.five_show=response.data.data['5'];
          }
          if(response.data.data['4'] !=0){
            this.four=Math.round(response.data.data['4']/response.data.data['all']*100);
            this.four_show=response.data.data['4'];
          }
          if(response.data.data['3'] !=0){
            this.three=Math.round(response.data.data['3']/response.data.data['all']*100);
            this.three_show=response.data.data['3'];
          }
          if(response.data.data['2'] !=0){
            this.two=Math.round(response.data.data['2']/response.data.data['all']*100);
            this.two_show=response.data.data['2'];
          }
          if(response.data.data['1'] !=0){
            this.one=Math.round(response.data.data['1']/response.data.data['all']*100);
            this.one_show=response.data.data['1'];
          }
          if(this.all_show>0){
            this.initInfoData();
          }
        }
      })
    },
    initInfoData(){
      const options={
        guideId:this.guideId,
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        searchType:this.searchType
      }
      var tt=this;
      this.$https.post("api/guide/getGuideScoreInfoListWeb.do",options,response=>{
        if (response.status === 200 && response.data.code===200 && response.data.data) {
          tt.total=response.data.data['total'];
          if(response.data.data['listData'] !=0){
            tt.dataObjList=response.data.data['listData']
          }
        }
      })
    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    }
  }
}



</script>
<style>

 .conment_con1_star .el-rate__icon {
    font-size: 30px;
    margin-right:0px;
    color: #C0C4CC;
    -webkit-transition: .3s;
    transition: .3s;
  }
</style>



// WEBPACK FOOTER //
// src/pages/guide/GuideIndexList.vue